import React from 'react';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import * as companyAutocompleteActions from '../../company/actions/companyAutocompleteActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

class CompanyAutocomplete extends React.Component {

    render() {
        const {
            company,
            loading,
            companyAutocompleteActions,
            id,
            onlyActive,
            onChange,
            companies,
            placeholder,
            disabled,
            handleTypeaheadRef,
            onBlur
        } = this.props;

        let companiesSelected = [];
        if ( company && company.id ) {
            companiesSelected.push(company);
        }

        const className = classNames(
            'input-autocomplete form-line',
            { 'disabled': disabled },
        );

        return (
            <AsyncTypeahead
                ref={handleTypeaheadRef}
                isLoading={loading}
                onSearch={query => {
                    companyAutocompleteActions.getCompanies(id, query, onlyActive);
                }}
                labelKey="name"
                selected={companiesSelected}
                onChange={onChange}
                options={companies}
                className={className}
                placeholder={placeholder}
                disabled={disabled}
                onBlur={onBlur}
                useCache={false}
            />
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        companies: state.companiesAutocomplete.companies && state.companiesAutocomplete.companies[ownProps.id] ? state.companiesAutocomplete.companies[ownProps.id] : [],
        loading: state.companiesAutocomplete.loading[ownProps.id] || false,
    };
};

const mapDispatchToProps = dispatch => ( {
    companyAutocompleteActions: bindActionCreators(companyAutocompleteActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAutocomplete);

CompanyAutocomplete.propTypes = {
    company: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    onlyActive: PropTypes.bool,
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    handleTypeaheadRef: PropTypes.func,
    onBlur: PropTypes.func,
};

CompanyAutocomplete.defaultProps = {
    onChange: () => {},
    disabled: false,
    onlyActive: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/CompanyAutocomplete.js